@let hasBadge = hasOrcidBadge();
@let orcidUrl = orcidUrl$ | async;

@if (hasBadge || orcidUrl) {
  <span class="d-flex align-items-center txt-value">
  @if (orcidUrl) {
    <a href="{{orcidUrl}}/{{metadataValue}}" target="_blank">
      {{ metadataValue }}
    </a>
  } @else {
    {{ metadataValue }}
  }

  @if (hasBadge) {
    <img
      placement="top"
      ngbTooltip="{{ 'orcid.badge.tooltip' | translate }}"
      class="orcid-icon"
      [alt]="'metadata-link-view.orcid.logo' | translate"
      src="assets/images/orcid.logo.icon.svg"/>
  }
</span>
}
